import {useLocation} from 'react-router-dom';
import {GlobalStyles} from './styles/globalStyles';
import Routes from './routes';
import AppAuthenticatedShell from './components/app/app-authenticated-shell';
import {AppAuthRedirect, AppMountEffects, AppSessionEffects} from './components/app/app-effects';
import BillingNotice from './components/billing-notice/billing.notice';
import {ENABLE_BILLING} from './config/features';

function App() {
    const {pathname} = useLocation();
    const isAuthRoute = pathname === '/auth';

    return (
        <>
            <AppMountEffects />
            <AppSessionEffects />
            <AppAuthRedirect />
            <GlobalStyles />
            {ENABLE_BILLING && <BillingNotice />}
            {isAuthRoute ? <Routes /> : <AppAuthenticatedShell />}
        </>);
}

export default App;
